import type { Work } from '../manifest';

/** prev/next within the work's cluster, in manifest order, wrapping. */
export function neighbors(works: Work[], id: string): { prev: Work; next: Work } {
  const current = works.find((x) => x.id === id)!;
  const siblings = works.filter((x) => x.cluster === current.cluster);
  const i = siblings.findIndex((x) => x.id === id);
  return {
    prev: siblings[(i - 1 + siblings.length) % siblings.length],
    next: siblings[(i + 1) % siblings.length],
  };
}
